import request from "@/utils/request";
// 获取区域
export function getArea(areaCode) {
  return request({
    url: "/wechat/base/area/tree",
    method: "get",
    params: {
      areaCode
    }
  });
}

// 获取字典
export function allSelectdictionaryData(data) {
  return request({
    url: "/wechat/system/dict/datas?dictTypes=" + data,
    method: "get"
  });
}

// 民生字典匹配
export function getLabel(data) {
  return request({
    url: "/wechat/intelligent/peopleslivelihood/pension/adviser/label",
    method: "get",
    params: data
  });
}
